import classNames from 'classnames';
import React from 'react';
import { useRecoilValue } from 'recoil';
import SmallText from 'src/components/SmallText';
import { imagesDataState, mainTabState, subTabState } from '../../store/state';
import ImageStars from '../ImageStars';
import styles from './index.module.scss';
const MyRankPanel = () => {
  const tab = useRecoilValue(mainTabState);
  const subtab = useRecoilValue(subTabState(1));
  const {
    result: { numberRank, fightingRank }
  } = useRecoilValue(imagesDataState);
  const rank = subtab === 1 ? numberRank : fightingRank;
  return (
    <div
      className={classNames(
        styles.container,
        tab === 1 ? styles.show : styles.hide,
        subtab === 2 && !fightingRank.title && styles.empty
      )}
    >
      {subtab === 2 && !fightingRank.title ? (
        <span>暂无座驾</span>
      ) : (
        <>
          {rank.rank > 0 ? (
            <div className={styles.rank}>{rank.rank}</div>
          ) : (
            <SmallText className={styles.rank} fontSize={22} inline>
              未入围
            </SmallText>
          )}
          {rank.logoUrl && (
            <img src={rank.logoUrl} alt="" className={styles.avatar} />
          )}
          {subtab === 1 ? (
            <div className={styles.nickname}>{rank.nickname}</div>
          ) : rank.title ? (
            <div className={styles.nickname}>
              {rank.title}
              <ImageStars count={rank.starLevel || 0} />
              <div className={styles.owner}>拥有人：{rank.nickname}</div>
            </div>
          ) : null}

          {rank.score > 0 && <div className={styles.score}>{rank.score}</div>}
        </>
      )}
    </div>
  );
};

export default React.memo(MyRankPanel);
